// extracted by mini-css-extract-plugin
module.exports = {"Root":"Horizontal_Root__3_6HH","RootNormal":"Horizontal_RootNormal__8hM6c"};